import { render } from "./UploadBtn.vue?vue&type=template&id=6e26ed1d&scoped=true"
import script from "./UploadBtn.vue?vue&type=script&lang=js"
export * from "./UploadBtn.vue?vue&type=script&lang=js"

import "./UploadBtn.vue?vue&type=style&index=0&id=6e26ed1d&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e26ed1d"]])

export default __exports__